import React from 'react';
import './SearchResults.css';
import TrackList from '../TrackList/TrackList.js';

/*
class SearchResults extends React.Component {
  render() {
    return (
      <div className="SearchResults">
        <h2>Results</h2>
        <TrackList
        onAdd={this.props.onAdd}
        tracks={this.props.tracks}/>
      </div>
    );
  }
}

export default SearchResults;
*/
class SearchResults extends React.Component {

  constructor(props){
    super(props);

    this.isRemoval = false;
  }

  render() {
    return (
      <div className="SearchResults">
        <h2>Results</h2>
        <TrackList tracks={this.props.searchResults} isRemoval={this.isRemoval} onAdd={this.props.onAdd} />
      </div>
    );
  }
}

export default SearchResults;





// WEBPACK FOOTER //
// ./src/Components/SearchResults/SearchResults.js